import { render, staticRenderFns } from "./LPS.vue?vue&type=template&id=acf44028&scoped=true"
import script from "./LPS.vue?vue&type=script&lang=js"
export * from "./LPS.vue?vue&type=script&lang=js"
import style0 from "./LPS.vue?vue&type=style&index=0&id=acf44028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf44028",
  null
  
)

export default component.exports